interface Props { active?: boolean }
export function TrainIcon({ active }: Props) {
  const sw = active ? 2.4 : 1.7;
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none">
      <path
        d="M3 13h2M21 13h2M6 9h2v8H6zM18 9h2v8h-2zM9 11h8v4H9z"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinejoin="round"
      />
    </svg>
  );
}
